const NotFoundError = () => {
    return(
        <div className="error">
              <h1>Sorry ...</h1>
              <p>There's nothing here!</p>
        </div>
    )
}

export default NotFoundError;